import { render, staticRenderFns } from "./add-employee-group-header.vue?vue&type=template&id=799adc26&scoped=true"
import script from "./add-employee-group-header.vue?vue&type=script&lang=js"
export * from "./add-employee-group-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799adc26",
  null
  
)

export default component.exports